module.exports = __webpack_public_path__ + "static/media/courses_avatar.308ad0c2.jpg";